import { legHasReducedQuotedSize } from "../../colDefs/colDefsShared";

/**
 * Returns the quoted percentage for a single leg, or null when the cell
 * should render blank (no diff, or quotedSize is blank/missing).
 */
export function calculateQuotedPercentForLeg(leg: any): number | null {
  if (!legHasReducedQuotedSize(leg)) return null;
  const notional = Number(leg.notionalLeg1);
  const quoted = Number(leg.quotedSize);
  if (!notional || isNaN(notional) || isNaN(quoted)) return null;
  return (quoted / notional) * 100;
}

/**
 * Returns the aggregate quoted percentage across an ER's legs, or null when
 * the cell should render blank (no leg has a diff, or sums are unusable).
 */
export function calculateQuotedPercentForER(legs: any[]): number | null {
  if (!legs?.length) return null;
  if (!legs.some(legHasReducedQuotedSize)) return null;

  let notionalSum = 0;
  let quotedSum = 0;
  for (const leg of legs) {
    notionalSum += Number(leg.notionalLeg1) || 0;
    quotedSum += Number(leg.quotedSize) || 0;
  }
  if (notionalSum === 0) return null;
  return (quotedSum / notionalSum) * 100;
}
